<template id="orderDetails">
<section id="shopingCart">
  <div class="container">
    <billInfo :res="res" :common_res="common_res" :shippinginfo="shippinginfo" :companyinfo="companyinfo" :invoice="{'status':invoice.status,'curdate':curdate,'invoiceNo':invoiceNo, 'picode':invoice.picode}"></billInfo>
    <!------desktop version---->
    <div class="proTables hidden-xs">
      <div class="row">
        <div class="col-sm-12"> 
          <!---------->
          <div class="table-responsive">
            <table class="table table-hover" id="cartP">
              <thead>
                <tr>
                  <th scope="col" class="text-center">{{res.productid}}</th>
                  <th scope="col" class="text-center">{{res.product}}</th>
                  <th scope="col" class="text-center">{{res.pname}} <i style="cursor:pointer" v-on:click="dnProductsList" class="fa fa-download"></i></th>
                  <th scope="col" class="text-center">{{res.order}} </th>
                  <th scope="col" class="text-center">{{res.qty}}</th>
                  <th scope="col" class="text-center">{{res.unitcost}}</th>
                  <th scope="col" class="text-center">{{res.discount}}</th>
                  <th scope="col" class="text-center">{{res.subtotal}}</th>
                </tr>
              </thead>
              <cartProduct :ocurr="curr" :fmt="fmt" :readonly="true" :common_res="common_res" :res="res" :stock="product.stock" v-for="(product, pidx) in products" :iscart="true" :details="product" :idx="pidx" v-on:calSubtotal="setSubTotal($event, st)" :key="product.pdetails.product_id"/>
              <tbody v-if="non_items != null" class="nobordertop"> 
                <template v-for="nitem in non_items">
                  <tr class="tiny" v-if="nitem.price != 0" v-bind:key="nitem">
                    <td></td>
                    <td></td>
                    <td colspan="5">
                      <span v-if="common_res['item_'+nitem.id] != null">{{common_res['item_'+nitem.id]}}</span>
                      <span v-else>{{nitem.name}}</span>
                      <span v-if="nitem.vat > 0" class="desc_txt"> ({{ common_res['order']['vat_include'] }})</span>
                      <br>
                    </td>
                    <td class="text-center">
                      <div class="subtotal"> {{curr}} <br>
                        <span v-if="nitem.price < 0" class="subTotal1"> ({{-1*nitem.price | format()}}) </span>
                        <span v-else class="subTotal1"> {{nitem.price | format()}} </span>
                      </div>
                    </td>
                  </tr>
                </template>
                <tr>
                  <td scope="row" class="text-center"><div class="productid"> </div></td>
                  <td class="text-center"></td>
                  <td class="text-center"></td>
                  <td class="text-center"><div class="order"> </div></td>
                  <td class="text-center"><div class="qty"> </div></td>
                  <td class="text-center"><div class="unitcost"></div></td>
                  <td class="text-center"><div class="finaltotal"> {{res.total}}</div></td>
                  <td class="text-center"><div class="finalsubtotal"> {{curr}}
                    <span class="subtotallast"> {{ftotal | format(fmt)}} </span>
                  </div></td>
                </tr>
              </tbody>
              <tbody class="nobordertop" v-else>
                <tr class="tiny" v-if="cart != null && cart.delivery_id != null">
                  <td></td>
                  <td></td>
                  <td colspan="5">
                    {{chargedDelivery.name}}<br>
                    <span v-if="chargedDelivery.ctype == 'PT' && chargedDelivery.dprice > 0" class="desc_txt">+{{(chargedDelivery.dprice * 100 * -1) | format()}}% surcharge</span>
                    <span v-else-if="chargedDelivery.ctype == 'AT' && chargedDelivery.dprice > 0" class="desc_txt">+{{(chargedDelivery.dprice * -1) | format()}} surcharge</span>
                  </td>
                  <td class="text-center">
                    <div class="subtotal"> {{curr}} <br>
                      <span class="subTotal1"> {{cart.delivery_cost | format(fmt)}} </span>
                    </div>
                  </td>
                </tr>
                <tr class="tiny" v-if="cart != null && cart.payment_id != null">
                  <td></td>
                  <td></td>
                  <td colspan="5">
                    {{chargedPayment.name}}<br>
                    <span v-if="chargedPayment.dprice > 0" class="desc_txt">+{{(chargedPayment.dprice * 100 * -1) | format()}}% surcharge</span>
                  </td>
                  <td class="text-center">
                    <div class="subtotal"> {{curr}} <br>
                      <span class="subTotal1"> {{cart.payment_cost | format(fmt)}} </span>
                    </div>
                  </td>
                </tr>
                <template v-for="ex in cart.extras">
                  <tr class="tiny" v-if="ex.dprice != 0" v-bind:key="ex">
                    <td></td>
                    <td></td>
                    <td colspan="5">
                      <span v-if="common_res['item_'+ex.id] != null">{{common_res['item_'+ex.id]}}</span>
                      <span v-else>{{getItemName(ex, cart.extralist)}}</span>
                      <br>
                      <span class="desc_txt"></span>
                    </td>
                    <td class="text-center">
                      <div class="subtotal"> {{curr}} <br>
                        <span v-if="ex.dprice > 0" class="subTotal1"> {{ex.dprice | format(fmt)}} </span>
                        <span v-else class="subTotal1"> ({{(ex.dprice * -1) | format(fmt)}}) </span>
                      </div>
                    </td>
                  </tr>
                </template>
                <tr>
                  <td scope="row" class="text-center"><div class="productid"> </div></td>
                  <td class="text-center"></td>
                  <td class="text-center">
                    <template v-for="cdis in cart.discountlist">
                      <div class="productname" v-if="cdis.cdprice < 0" v-bind:key="cdis">{{cdis.cdprice}} {{ cdis }}</div>
                    </template>
                    <!--div class="productname" v-if="cart.payment_id != null">{{cart.payment_cost}}</div-->
                    <!--div class="productname" v-for="(ex, eidx) in cart.extras" v-if="ex.dprice != 0">{{ex.dprice}}</div-->
                  </td>
                  <td class="text-center"><div class="order"> </div></td>
                  <td class="text-center"><div class="qty"> </div></td>
                  <td class="text-center"><div class="unitcost"></div></td>
                  <td class="text-center"><div class="finaltotal"> {{res.total}}</div></td>
                  <td class="text-center"><div class="finalsubtotal"> {{curr}} 
                    <span class="subtotallast"> {{ftotal | format(fmt)}} </span>
                    <!--span v-if="ototal != null" class="subtotallast"> {{ototal | format()}} </span>
                    <span v-else class="subtotallast"> {{totala | format()}} </span-->
                  </div></td>
                </tr>
              </tbody>
            </table>
          </div>
          <!--------> 
        </div>
        <!--div class="row"-->
          <div class="col-md-12 col-sm-12 text-center">
            <input v-if="amendable " class="form-control submitButton" :value="res.amend" type="submit" v-on:click="amendOrder($event)">
            <!--input v-if="payable != null && topay_btn == true" class="form-control submitButton" :value="res.pay" type="submit" v-on:click="payOrder($event, payable)"-->
            <input v-if="slist.indexOf('thanks') < 0" class="form-control submitButton" :value="res.back" type="submit" v-on:click="goBack($event)">
          </div>
          <!--div class="col-xs-12 text-center">
            <div class="centerbutton amend">
              <input v-if="amendable" class="redButon" :value="res.amend" type="submit" v-on:click="amendOrder($event)">
              <input v-if="slist.indexOf('thanks') < 0" class="redButon" :value="res.back" type="submit" v-on:click="goBack($event)">
            </div>
          </div-->
        <!--/div-->
      </div>
    </div>
    <!------mobile version---->
    <div class="mobilepro visible-xs">
      <div class="row"> 
        <!-------->
        <div class="col-sm-12">
          <div class="mobileproduct" id="mCartP">
            <div class="formHeadings"> <span><img src="@/images/valueicon.png" alt="#"></span>Product</div>
            <mCartProduct :fmt="fmt" :readonly="true" :common_res="common_res" :res="res" :stock="product.stock" v-for="(product, pidx) in products" :iscart="true" :details="product" :idx="pidx" v-on:calSubtotal="setSubTotal($event, st)" :key="product.pdetails.product_id"/>
            <!--mCartProduct :readonly="true" v-for="(product, pidx) in products" :common_res="common_res" :res="res" :details="product" :iscart="true" :idx="pidx" v-on:calSubtotal="setSubTotal($event, st)" :key="product.pdetails.product_id"/-->
            <template v-for="cdis in cart.discountlist">
              <div class="pull-right label" v-if="cdis.cdprice < 0" v-bind:key="cdis">{{cdis.cdprice}}</div>
            </template>

            <div v-for="nitem in non_items" class="mobcharge">
              <div class="mobdiscount1" v-if="nitem.price != 0">
                <div class="pull-left">
                  <div class="mobileunitcost1">
                    <span v-if="common_res['item_'+nitem.id] != null" v-html="common_res['item_'+nitem.id]"></span>
                    <span v-else v-html="nitem.name"></span>
                    <span v-if="nitem.vat > 0" class="desc_txt"><br>{{ common_res['order']['vat_include'] }}</span>
                    <br>
                  </div>
                </div>
                <div class="pull-right">
                  <div class="mobileunitcost"></div>
                  <div class="mobileunithkdvalue"> {{curr}} <br/>
                    <span v-if="nitem.price < 0" class="subTotal1"> ({{-1*nitem.price | format()}}) </span>
                    <span v-else class="subTotal1"> {{nitem.price | format()}} </span>
                  </div>
                </div>
              </div>
            </div>


<!--

            <div class="mobcharge" v-if="cart.delivery_id != null">
              <div class="mobdiscount1">
                <div class="pull-left">
                  <div class="mobileunitcost1">
                    {{chargedDelivery.name}}<br>
                    <span v-if="chargedDelivery.ctype == 'PT' && chargedDelivery.dprice > 0" class="desc_txt">+{{(chargedDelivery.dprice * 100 * -1) | format()}}% surcharge</span>
                    <span v-else-if="chargedDelivery.ctype == 'AT' && chargedDelivery.dprice > 0" class="desc_txt">+{{(chargedDelivery.dprice * -1) | format()}} surcharge</span>
                  </div>
                </div>
                <div class="pull-right">
                  <div class="mobileunitcost"></div>
                  <div class="mobileunithkdvalue"> {{curr}} {{cart.delivery_cost |format(fmt)}} </div>
                </div>
              </div>
            </div>
            <div class="mobcharge" v-if="cart.payment_id != null">
              <div class="mobdiscount1">
                <div class="pull-left">
                  <div class="mobileunitcost1">
                    {{chargedPayment.name}}<br>
                    <span v-if="chargedPayment.dprice > 0" class="desc_txt">+{{(chargedPayment.dprice * 100 * -1) | format()}}% surcharge</span>
                  </div>
                </div>
                <div class="pull-right">
                  <div class="mobileunitcost"></div>
                  <div class="mobileunithkdvalue"> {{curr}} {{cart.payment_cost |format(fmt)}} </div>
                </div>
              </div>
            </div>
-->
            <template v-for="ex in cart.extras">
              <div class="mobcharge" v-if="ex.dprice != 0" v-bind:key="ex">
                <div class="mobdiscount1">
                  <div class="pull-left">
                    <div class="mobileunitcost1">
                      <span v-if="common_res['item_'+ex.id] != null">{{common_res['item_'+ex.id]}}</span>
                      <span v-else>{{getItemName(ex, cart.extralist)}}</span>
                      <br>
                      <span class="desc_txt"></span>
                    </div>
                  </div>
                  <div class="pull-right">
                    <div class="mobileunitcost"></div>
                    <div v-if="ex.dprice > 0" class="mobileunithkdvalue"> {{curr}} {{ex.dprice |format(fmt)}} </div>
                    <div v-else class="mobileunithkdvalue"> {{curr}} ({{(ex.dprice * -1) |format(fmt)}}) </div>
                  </div>
                </div>
              </div>
            </template>
            <div class="totalcalvalue">
              <div class="pull-left"><img src="@/images/valueicon.png" alt="image"></div>
              <div class="pull-right">
                <div class="totalcal"> <span> Total </span> <span class="valuehkd"> {{curr}} </span> 
                  <span class="valueno"> {{ftotal | format(fmt)}} </span>
                  <!--span v-if="ototal != null" class="valueno"> {{ototal | format()}} </span>
                  <b v-else class="valueno"> {{totala | format()}} </span-->
                </div>
              </div>
            </div>
          </div>
        </div>
        <!----------> 
        <!--div class="row"-->
          <div class="col-md-12 col-sm-12 text-center">
            <input v-if="amendable" class="form-control submitButton" :value="res.amend" type="submit" v-on:click="amendOrder($event)">
            <!--input v-if="payable != null" class="form-control submitButton" :value="res.pay" type="submit" v-on:click="payOrder($event, payable)"-->
            <input v-if="slist.indexOf('thanks') < 0" class="form-control submitButton" :value="res.back" type="submit" v-on:click="goBack($event)">
          </div>
          <!--div class="col-xs-12 text-center">
            <div class="centerbutton amend">
              <input v-if="amendable" class="redButon" :value="res.amend" type="submit" v-on:click="amendOrder($event)">
              <input class="redButon" :value="res.back" type="submit" v-on:click="goBack($event)">
            </div>
          </div-->
        <!--/div-->
      </div>
    </div>
    <!---------->

    <div class="shopBlock" v-if="invoice.shoporder != null && !isPaid" id="topay">
      <div class="row">
        <div class="col-xs-12">
          <div class="formHeadings"> <span><img src="@/images/advanced.png" alt="#"></span>{{res.payinst}}</div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12 col-sm-12 col-xs-12">
          <div v-if="invoice.stripe_key != null && payable == 'CC'" class="payinstruct creditcard">
            <div class="payinstructimage">
              <img src="@/images/creditcardicon.png" alt="image">
              <h4 v-html="res.bycc">By credit card</h4>
            </div>
            <div v-if="clientSecret!= null" id="paycc" class="payinstructdesc spec_list">
              <table>
                <tbody>
                  <tr>
                    <td v-html="res.ccname"></td>
                    <td><input type="text" id="cardholder-name" style="padding:0.25em 0.5em"></td>
                  </tr>
                  <tr>
                    <td colspan="2">
                      <div id="card-element">
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="payinstructdesc">
              <h4 v-if="topay_btn == true" v-html="res.cc_desc"> Please click here for payment by Credit Card</h4>
              <p v-if="topay_btn == true"></p>
              <input v-if="topay_btn == true" class="redButton promptPayDialog" :value="clientSecret==null?res.pay:res.paycc" type="submit" v-on:click="payCC($event, payable)"/>
            </div>
          </div>
          <div v-else-if="payable == 'QR'" class="payinstruct">
            <div class="payinstructimage">
              <img src="@/images/icon-fps_qr.png" alt="image"/>
              <h4 v-html="res.byfps">By FPS QR code</h4>
            </div>
            <div class="payinstructdesc">
              <h4 v-if="topay_btn == true" v-html="res.fps_desc"> Please click here for payment by FPS QR Code </h4>
              <p v-if="topay_btn == true"></p>
              <!--input class="redButon promptPayDialog" value=" Pay order " type="submit"-->
              <input v-if="topay_btn == true" class="redButton promptPayDialog" :value="res.pay" type="submit" v-on:click="payOrder($event, payable)"/>
              <div class="paydialog" v-if="qrcode != null" style="display:block">
                <div class="paydialog_contents">
                  <p v-html="res.scan">Please scan the QR code to proceed payment</p>
                  <img class="qrimg" :src="qrcode"/>
                </div>
              </div>
            </div>
          </div>
          <div v-else class="payinstruct">
            <div v-if="payable == 'QR'" class="payinstructimage">
              <img src="@/images/icon-qr.png" alt="image">
              <h4>By FPS QR code</h4>
            </div>
            <div v-else-if="payable == 'CC'" class="payinstructimage">
              <img src="@/images/creditcardicon.png" alt="image">
              <h4 v-html="res.bycc">By credit card</h4>
            </div>
            <div v-else class="payinstructimage">
              <img src="@/images/bankicon.png" alt="image">
              <h4 v-html="res.bybankin">By bank-in</h4>
            </div>
            <div class="payinstructdesc">
              <div v-if="1==2">
                <!-- a credit card form ?? -->
              </div>
              <div v-else-if="common_res.payment.instructions" class="payinstructdesc" v-html="common_res.payment.instructions">
              </div>
              <ul v-else>
                <li><b>{{res.bank}}: </b> {{country_payinfo.bank}}</li>
                <li><b>{{res.bankacc}}: </b> {{country_payinfo.bankacc}} </li>
                <li><b>{{res.accname}}: </b> <a style="color:#ffffff" href="mailto:info@sampsonstore.com">{{country_payinfo.accname}}</a> </li>
                <li v-if="country_payinfo.swiftcode"><b>{{res.swiftcode}} :</b> {{country_payinfo.swiftcode}}</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--
    <div class="shopBlock cards" v-if="invoice.shoporder != null && qrcode != null">
      <div class="row">
        <div class="col-xs-12">
          <div class="formHeadings"> <span><img src="@/images/advanced.png" alt="#"></span>{{res.payinst}}</div>
        </div>
      </div>
      <div class="row">
        <div v-if="common_res.payment.instructions" class="col-xs-12 shopbtm" v-html="common_res.payment.instructions">
        </div>
        <div v-else class="col-xs-12 shopbtm">
          <p> <span class="largetext">{{res.bank}} :</span> {{country_payinfo.bank}}</p>
          <p> <span class="largetext">{{res.bankacc}} :</span> {{country_payinfo.bankacc}}</p>
          <p> <span class="largetext">{{res.accname}} :</span> <a href="mailto:info@sampsonstore.com">{{country_payinfo.accname}}</a></p>
          <p v-if="country_payinfo.swiftcode"> <span class="largetext">{{res.swiftcode}} :</span> {{country_payinfo.swiftcode}}</p>
        </div>
        <div class="col-md-6 col-sm-12 col-xs-12">
          <img :src="qrcode"/>
        </div>
      </div>
    </div>
    -->
    <div class="shopBlock cards" v-if="invoice.shoporder != null">
      <div class="row">
        <div class="col-xs-12">
          <div class="formHeadings"> <span><img src="@/images/truck.png" alt="#"></span> {{res.shippingdetails}}</div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6 col-sm-12 col-xs-12">
          <div class="boxOuter orderboxouter">
            <a href="javascript:void(0)">
              <div class="box">
                <div class="heading">
                  <h6> {{res.deliverby}} </h6>
                </div>
                <!--div class="orderboximg marginTop"><img :src="pageRoot+'/images/'+invoice.shoporder.delivery_id+'.png'" alt=""></div-->
                <!--div class="orderboximg marginTop"><img :src="'/img/delivery/'+invoice.shoporder.delivery_id+'.gif'" alt=""></div-->
                <div class="orderboximg marginTop"><img :src="deliveryImgPath" alt=""></div>
                <div class="orderboxinfo"> {{tracking.name}} </div>
              </div>
            </a>
          </div>
          <div class="boxOuter orderboxouter" v-if="invoice.shoporder.exp_arr_date != ''">
            <a target="_blank" :href="tracking.url">
              <div class="box">
                <div class="heading">
                  <h6> {{res.trackingno}} </h6>
                </div>
                <div class="orderboxinfo" v-html="tracking.number"></div>
              </div>
            </a>
          </div>
        </div>
        <div class="col-md-6 col-sm-12 col-xs-12"> 
          <div class="boxOuter orderboxouter" v-if="invoice.shoporder.sent_date != ''">
            <a href="javascript:void(0)">
              <div class="box">
                <div class="heading">
                  <h6> {{res.etd}} </h6>
                </div>
                <div class="orderboximg orderboximg1"><img src="@/images/calendar.png" alt=""></div>
                <div class="orderboxinfo"> {{invoice.shoporder.sent_date|trimDate}} </div>
              </div>
            </a>
          </div>
          <div class="boxOuter orderboxouter" v-if="invoice.shoporder.exp_arr_date != ''">
            <a href="javascript:void(0)">
              <div class="box">
                <div class="heading">
                  <h6> {{res.eta}} </h6>
                </div>
                <div class="orderboximg orderboximg1"><img src="@/images/calendar.png" alt=""></div>
                <div class="orderboxinfo"> {{invoice.shoporder.exp_arr_date|trimDate}} </div>
              </div>
            </a>
          </div>
          <!----------> 
        </div>
      </div>
    </div>

<!--
    <div class="shopBlock">
      <div class="row">
        <div class="col-xs-12">
          <div class="formHeadings"> <span><img src="@/images/statusicon.png" alt="#"></span>Status</div>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-12"> 
           <div class="ordertStatus">
             <ul class="tabs">
                  <li></li>
                  <li class="active" rel="tab2">
                <div class="payHeadings"><span><img src="@/images/instruction.png" alt="#"></span>Payment instruction </div>
              </li>
                  <li rel="tab3" class="tab_last">
                <div class="payHeadings"><span><img src="@/images/shipment.png" alt="#"></span> Shipment status </div>
              </li>
            </ul>
          </div>
          <div class="tab_container">
            <h3 class="d_active  tab_drawer_heading" rel="tab2">Tab 2</h3>
            <div id="tab2" class="tab_content" style="display: block;"> 
              <div class="paymentinstruct">
                <ul>
                  <li>
                    <div class="orderdate">
                          <h5> 2017-11-24 </h5>
                          <p>16:22</p>
                    </div>
                    <div class="authorized">
                          <div class="tickimage"><img src="@/images/whitetick.png" alt="image"></div>
                          <div class="authorizedheading">Authorized </div>
                          <div class="credit"><img src="@/images/creditcard.png" alt="image"> </div>
                    </div>
                    <div class="shippingstatus">
                          <div class="shippingimage"><img src="@/images/delieveredicon.png" alt="#"></div>
                          <div class="shippingtitle"> Delievered </div>
                    </div>
                  </li>
                  <li>
                    <div class="orderdate">
                          <h5> 2017-11-23 </h5>
                          <p>16:22</p>
                        </div>
                    <div class="authorized">
                          <div class="tickimage"><img src="@/images/whitetick.png" alt="image"></div>
                          <div class="authorizedheading">Authorized </div>
                          <div class="credit"><img src="@/images/creditcard.png" alt="image"> </div>
                        </div>
                    <div class="shippingstatus">
                          <div class="shippingimage"><img src="@/images/delieveringicon.png" alt="#"></div>
                          <div class="shippingtitle"> Delivering </div>
                        </div>
                  </li>
                  <li>
                    <div class="orderdate">
                          <h5> 2017-11-23 </h5>
                          <p>16:22</p>
                        </div>
                    <div class="authorized">
                          <div class="tickimage"><img src="@/images/whitetick.png" alt="image"></div>
                          <div class="authorizedheading">Authorized </div>
                          <div class="credit"><img src="@/images/creditcard.png" alt="image"> </div>
                        </div>
                    <div class="shippingstatus">
                          <div class="shippingimage"><img src="@/images/packedicon.png" alt="#"></div>
                          <div class="shippingtitle"> Packed </div>
                        </div>
                  </li>
                  <li>
                    <div class="orderdate">
                          <h5> 2017-11-21 </h5>
                          <p>16:22</p>
                        </div>
                    <div class="authorized">
                          <div class="tickimage"><img src="@/images/whitetick.png" alt="image"></div>
                          <div class="authorizedheading">Authorized </div>
                          <div class="credit"><img src="@/images/bankin.png" alt="image"> </div>
                        </div>
                    <div class="shippingstatus">
                          <div class="shippingimage"><img src="@/images/processingicon.png" alt="#"></div>
                          <div class="shippingtitle"> Processing </div>
                        </div>
                  </li>
                  <li>
                    <div class="orderdate">
                          <h5> 2017-11-20 </h5>
                          <p>16:22</p>
                        </div>
                    <div class="authorized">
                          <div class="tickimage"><img src="@/images/pendingicon.png" alt="image"></div>
                          <div class="authorizedheading">Pending </div>
                        </div>
                    <div class="shippingstatus">
                          <div class="shippingimage"><img src="@/images/pendingshipicon.png" alt="#"></div>
                          <div class="shippingtitle"> Pending </div>
                        </div>
                  </li>
                </ul>
              </div>
            </div>
            <h3 class="tab_drawer_heading" rel="tab3">Tab 3</h3>
            <div id="tab3" class="tab_content" style="display: none;"> 
              <div class="paymentinstruct">
                <ul>
                  <li>
                    <div class="orderdate">
                          <h5> 2017-11-24 </h5>
                          <p>16:22</p>
                        </div>
                    <div class="authorized">
                          <div class="tickimage"><img src="@/images/whitetick.png" alt="image"></div>
                          <div class="authorizedheading">Authorized </div>
                          <div class="credit"><img src="@/images/creditcard.png" alt="image"> </div>
                        </div>
                    <div class="shippingstatus">
                          <div class="shippingimage"><img src="@/images/delieveredicon.png" alt="#"></div>
                          <div class="shippingtitle"> Delievered </div>
                        </div>
                  </li>
                  <li>
                    <div class="orderdate">
                          <h5> 2017-11-23 </h5>
                          <p>16:22</p>
                        </div>
                    <div class="authorized">
                          <div class="tickimage"><img src="@/images/whitetick.png" alt="image"></div>
                          <div class="authorizedheading">Authorized </div>
                          <div class="credit"><img src="@/images/creditcard.png" alt="image"> </div>
                        </div>
                    <div class="shippingstatus">
                          <div class="shippingimage"><img src="@/images/delieveringicon.png" alt="#"></div>
                          <div class="shippingtitle"> Delivering </div>
                        </div>
                  </li>
                  <li>
                    <div class="orderdate">
                          <h5> 2017-11-23 </h5>
                          <p>16:22</p>
                        </div>
                    <div class="authorized">
                          <div class="tickimage"><img src="@/images/whitetick.png" alt="image"></div>
                          <div class="authorizedheading">Authorized </div>
                          <div class="credit"><img src="@/images/creditcard.png" alt="image"> </div>
                        </div>
                    <div class="shippingstatus">
                          <div class="shippingimage"><img src="@/images/packedicon.png" alt="#"></div>
                          <div class="shippingtitle"> Packed </div>
                        </div>
                  </li>
                  <li>
                    <div class="orderdate">
                          <h5> 2017-11-21 </h5>
                          <p>16:22</p>
                        </div>
                    <div class="authorized">
                          <div class="tickimage"><img src="@/images/whitetick.png" alt="image"></div>
                          <div class="authorizedheading">Authorized </div>
                          <div class="credit"><img src="@/images/bankin.png" alt="image"> </div>
                        </div>
                    <div class="shippingstatus">
                          <div class="shippingimage"><img src="@/images/processingicon.png" alt="#"></div>
                          <div class="shippingtitle"> Processing </div>
                        </div>
                  </li>
                  <li>
                    <div class="orderdate">
                          <h5> 2017-11-20 </h5>
                          <p>16:22</p>
                        </div>
                    <div class="authorized">
                          <div class="tickimage"><img src="@/images/pendingicon.png" alt="image"></div>
                          <div class="authorizedheading">Pending </div>
                        </div>
                    <div class="shippingstatus">
                          <div class="shippingimage"><img src="@/images/pendingshipicon.png" alt="#"></div>
                          <div class="shippingtitle"> Pending </div>
                        </div>
                  </li>
                </ul>
              </div>
              </div>
          </div>
        </div>
      </div>
    </div>


    <div class="shopBlock">
      <div class="row">
        <div class="col-xs-12">
          <div class="formHeadings"> <span><img src="@/images/advanced.png" alt="#"></span> Advance payment instruction </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12 col-sm-12 col-xs-12"> 
          <div class="payinstruct">
            <div class="payinstructimage"> <img src="@/images/bankicon.png" alt="image">
                  <h4>By bank-in </h4>
            </div>
            <div class="payinstructdesc">
                  <ul>
                <li><b>Bank : </b> The Hongkong and Shanghai Banking Corporation Limited</li>
                <li><b>Bank Account : </b> 015-525975-001 </li>
                <li><b>Account Holder : </b> SAMPSONSTORE.COM LIMITED </li>
              </ul>
            </div>
          </div>
          <div class="payinstruct">
            <div class="payinstructimage"> <img src="@/images/creditcardicon.png" alt="image">
                  <h4> By credit card </h4>
            </div>
            <div class="payinstructdesc">
                  <h4> Please click here for payment by credit card </h4>
                  <p> (3.5% surcharge applies) </p>
                  <input class="redButon" value=" Click to credit card payment " type="submit">
            </div>
          </div>
          <div class="payinstruct">
            <div class="payinstructimage"> <img src="@/images/cheque.png" alt="image">
                  <h4>By cheque</h4>
            </div>
            <div class="payinstructdesc">
                  <h4> Please send cheque to :</h4>
                  <p> (Unit D, 3/F, V Ga Building, 532 Castle Peak Road, Lai Chi Kok, Kowloon, Hong Kong </p>
                  <input class="redButon" value=" To be confirmed by us " type="submit">
            </div>
          </div>
        </div>
      </div>
    </div>
-->
  </div>
</section>
</template>

<script>

import utils from './Utils.vue'
import cartProduct from './CartProduct.vue'
import mCartProduct from './MCartProduct.vue'
import billInfo from './BillInfo.vue'
import Vue from 'vue'
import VueResource from 'vue-resource'
import VueCookie from 'vue-cookie';
Vue.use(VueResource);
Vue.use(VueCookie);

export default {
  name: 'cart',
  props:['slist', 'name', 'countries', 'common_res', 'res', 'discountlist', 'companyinfo', 'invoice', 'paymentinfo'],
  data () {
    return {
      paytype:["QR", "CC"],
      stripe_txn_id:null,
      stripe_obj:null,
      cardElement:null,
      clientSecret:null,
      cc3d_path:null,
      locale:null,
      amendable:false,
      enqurl:null,
      enqInterval:null,
      payable:null,
      pay_by_cc:false,
      cc_secret:null,
      non_items:null,
      qrcode:null,
      curr:null,
      fmt:null,
      shippinginfo:null,
      shippingid:"-1",
      toshowaddrs:false,
      delivery_id:null,
      payment_id:null,
      deliveryImgPath:null,
      products:[],
      disinfo:[],
      token:null,
      submitted:false,
      totala:0,
      cart:{},
      subtotal:[],
      topay_btn:false,
      error:{}
    }
  },
  computed: {
    isPaid:function() {
      if (this.invoice.shoporder == null) return false;
      return this.invoice.shoporder == null?false:utils.getPaidStatus().indexOf(this.invoice.shoporder.payment_status_id) >= 0;
    },
    country_payinfo:function() {
      var country_id = this.companyinfo.country_id;
      var c = this.common_res.payment['country_id_'+country_id];
      if (c != null) return c;
      return this.common_res.payment['country_id'];
    },
    tracking:function() {
      var name = 'Delivery agent';
      if (this.invoice.non_items != null) {
        for (var i=0;i<this.invoice.non_items.length;i++) {
          if (utils.isDeliveryOptions(this.invoice.non_items[i].itype)) {
            name = this.invoice.non_items[i].name;
            break;
          }
        }
      }
      if (this.invoice.shoporder.merchant_comment == '') {
        return {"name":name};
      }
      //ele = new DOMParser().parse(this.invoice.shoporder.merchant_comment);
      var ele = document.createElement('div');
      ele.innerHTML = this.invoice.shoporder.merchant_comment;
      var ret = '';
      try {
        ret = {"url":ele.getElementsByTagName('a')[0].href, "number":ele.textContent, "name":name};
      } catch (e) {
        ele.innerHTML = this.invoice.shoporder.remark;
        try {
          ret = {"url":ele.getElementsByTagName('a')[0].href, "number":ele.textContent, "name":name};
        } catch (ee) {
        }
      }
      ele.remove();
      return ret;
    },
    ftotal:function() {
      if (this.invoice != null) {
        //return this.invoice.total_amount;
        return this.invoice.payment_amount;
      }
      var tt = 0;
      if (this.ototal != null) {
        tt = this.ototal;
      } else {
        tt = this.totala;
      }
      if (this.cart != null) {
        if (this.cart.payment_id != null) {
          tt = tt + this.cart.payment_cost;
        }
        if (this.cart.delivery_id != null) {
          tt = tt + this.cart.delivery_cost;
        }
        if (this.cart.extras != null) {
          for (var i=0;i<this.cart.extras.length;i++) {
            tt = tt + this.cart.extras[i].dprice;
          }
        }
      }
      return tt;
    },
    invoiceNo:function() {
      return this.invoice.bill_no;
    },
    curdate:function() {
      return new Date(Date.parse(this.invoice.entry_date));
    },
    pageRoot:function() {
      return utils.getPageRoot();
    }
  },
  components: {
    cartProduct,
    billInfo,
    mCartProduct
  },
  created: function() {
    this.init();
    var self = this;
    var img = new Image();
    if (this.paymentinfo != null && this.invoice.shoporder != null) {
      if (utils.getReadyToPayStatus().indexOf(this.invoice.shoporder.payment_status_id) >= 0) {
        self.qrcode = this.paymentinfo.base64;
        //$('.paydialog').slideToggle();
        self.enqurl = this.paymentinfo.enqurl;
        if (self.enqurl != null) {
          self.checkEnqURL();
        }
      }
    }
    if (this.invoice != null && this.invoice.shoporder != null) {
      var did = this.invoice.shoporder.delivery_id;
      img.addEventListener('load', function imgOnLoad() {
        self.deliveryImgPath = img.src;
      });
      img.addEventListener('error', function imgOnLoad() {
        self.deliveryImgPath = '/img/delivery/'+did+'.gif';
      });
      img.src = self.pageRoot+'/images/delivery/'+did+'.png';
    }
  },
  methods: {
    loadExternalScript(src) {
      return new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.type = 'text/javascript';
        script.src = src;
        script.async = true;

        script.onload = () => resolve();
        script.onerror = () => reject(new Error(`Failed to load script: ${src}`));

        document.head.appendChild(script);
      });
    },
    formatPrice(price) {
      return Vue.filter('format')(price);
    },
    getDays(hours) {
      return parseInt(hours / 24);
    },
    getHours(hours) {
      return parseInt(hours % 24);
    },
    getItemName(item, list) {
      if (list == null) return null;
      for (var i=0;i<list.length;i++) {
        if (list[i].id == item.id) {
          return list[i].name;
        }
      }
      return null;
    },
    reOrder(evt) {
      var self = this;
      self.$root.$emit('remove', {'all':true});
      self.$root.$once('cart', data => {
        if ('deleted' == data.action) {
          var aqty = {};
          for (var i=0;i<self.products.length;i++) {
            var product_id = self.products[i].pdetails.product_id;
            aqty[self.products[i].pdetails.product_id] = parseInt(self.products[i].fqty);
            var qty = self.products[i].oqty;
            self.$root.$emit('buy', {'mode':'batch', details:self.products[i], oqty:self.products[i].oqty});
          }
          //localStorage['sampsonstore.b2b.cart.aqty'] = JSON.stringify(aqty);
          utils.saveStorage('cart.aqty', aqty);
          window.location = "../cart/index.html";
        }
      });
    },
    goBack(evt) {
      window.location = "../order/index.html";
    },
    checkEnqURL() {
      var self = this;
      self.enqInterval = setInterval(function() {
        var formdata = new FormData();
        //formdata.append('txn_id', self.invoice.bill_no + '-' + self.invoice.invid);
        // no need to append invid @20210322
        formdata.append('txn_id', self.invoice.bill_no);
        formdata.append('invid', self.invoice.invid);
        formdata.append('bill_no', self.invoice.bill_no);
        Vue.http.post(utils.getServerPath()+'/order/'+self.enqurl, formdata).then(response => {
          if (response.body.paymentinfo != null && response.body.paymentinfo.doneurl != null) {
            clearInterval(self.enqInterval);
            self.enqInterval = null;
            window.location.href = response.body.paymentinfo.doneurl;
          }
        });
      }, 5000);
    },
    submitCC(evt) {
      var self = this;
      self.$root.$emit('modal.msgoverlay', {'mode':'show', 'msg':self.common_res.message.waiting});
      self.stripe_obj.confirmPaymentIntent(
        self.clientSecret, self.cardElement, {
          payment_method_data: {
            billing_details: {name: document.getElementById('cardholder-name').value}
          },
          return_url: self.cc3d_path
        }
      ).then(function(result) {
        console.log(result.paymentIntent.status);
        if (result.paymentIntent.status == 'requires_source_action' || result.paymentIntent.status == 'requires_action') {
          self.$root.$emit('modal.msgoverlay', {'mode':'hide'});
          setTimeout(function() {
            self.$root.$emit('modal.blank', {'mode':'show'});
            setTimeout(function() {
              var iframe = document.createElement('iframe');
              iframe.id = '3ds';
              iframe.style.width = "100%";
              iframe.style.height= "600px";
              iframe.src = result.paymentIntent.next_action.redirect_to_url.url;
              $('#blank .modal-dialog .modal-content .modal-body').append(iframe);
            }, 100);
          }, 100);
        }
        if (result.error != null) {
          //self.$root.$emit('modal.msgoverlay', {'mode':'hide'});
          self.$root.$emit('modal.msgoverlay', {'mode':'show', 'msg':result.error.code, 'button':self.common_res.message.close, 'icon':'fa-exclamation'});
          //alert(result.error.message);
        } else if (self.enqurl != null) {
          //self.$root.$emit('modal.msgoverlay', {'mode':'show', 'msg':self.common_res.message.waiting});
          self.checkEnqURL();
        } else {
          self.$root.$emit('modal.msgoverlay', {'mode':'hide'});
        }
      }).catch(err => {
        console.log(err);
        self.$root.$emit('modal.msgoverlay', {'mode':'hide'});
        //window.location.reload();
      });
    },
    payCC(evt, pay) {
      var self = this;
      if (self.clientSecret != null) {
        return self.submitCC();
      }
      if (self.payable != 'CC') {
        return;
      }
      var buttons = [
        {
          "value":self.common_res.message.yes,
          "func":function() {
            self.$root.$emit('modal.msgoverlay', {'mode':'show', 'msg':self.common_res.message.waiting});
            self.loadExternalScript('https://js.stripe.com/v3/').then(() => {
              self.stripe_obj = Stripe(self.invoice.stripe_key,'{locale:"'+self.invoice.locale_str+'"}');
              self.clientSecret = ''
              //self.cc_secret = 'testing'
              var style = {
                base: {
                  fontSize: '14px',
                  color: "#686969",
                  fontFamily: "Montserrat, sans-serif"
                }
              };
              var elements = self.stripe_obj.elements({locale:'en'});
              self.cardElement = elements.create('card', {style: style});
              var formdata = new FormData();
              //formdata.append('txn_id', self.invoice.bill_no + '-' + self.invoice.invid);
              // no need to append invid @20210322
              formdata.append('invid', self.invoice.invid);
              formdata.append('bill_no', self.invoice.bill_no);
              formdata.append('amount', self.invoice.payment_amount);
              formdata.append('curr', self.invoice.currency_symbol);
              self.amendable = false;
              Vue.http.post(utils.getServerPath()+'/order/payCC.is', formdata).then(response => {
                console.log('payCC', response);
                self.$root.$emit('modal.msgoverlay', {'mode':'hide'});
                self.clientSecret = response.body.payintent;
                self.enqurl = response.body.paymentinfo.enqurl;
                self.cc3d_path = response.body.paymentinfo.cc3d_path;
                self.cardElement.mount('#card-element');
              });
              //setTimeout(function() {
              //  cardElement.mount('#card-element');
              //}, 1000);
              //console.log(stripe);
            });
          }
        },
        {
          "value":self.common_res.message.no
        }
      ];
      this.$root.$emit('modal.msgoverlay', {'mode':'show', 'msg':self.res.confirm_pay_cc, 'icon':'fa-question', 'buttons':buttons});
    },
    payOrder(evt, pay) {
      var self = this;
      var buttons = [
        {
          "value":self.common_res.message.yes,
          "func":function() {
            //self.$root.$emit('remove', {'all':true});
            self.$root.$emit('modal.msgoverlay', {'mode':'show', 'msg':self.common_res.message.waiting});
            console.log(pay, self.invoice);
            var formdata = new FormData();
            //formdata.append('txn_id', self.invoice.bill_no + '-' + self.invoice.invid);
            // no need to append invid @20210322
            formdata.append('txn_id', self.invoice.bill_no);
            formdata.append('invid', self.invoice.invid);
            formdata.append('bill_no', self.invoice.bill_no);
            self.amendable = false;
            Vue.http.post(utils.getServerPath()+'/order/pay'+pay+'.is', formdata).then(response => {
              self.topay_btn = false;
              self.$root.$emit('modal.msgoverlay', {'mode':'hide'});
              if (response.body.paymentinfo != null) {
                if (response.body.paymentinfo.payment_status_id != null) {
                  self.invoice.shoporder.payment_status_id  = response.body.paymentinfo.payment_status_id;
                }
                console.log(self.invoice.shoporder.payment_status_id, self.topay_btn);
                //console.log('payOrder', response.body);
                self.qrcode = response.body.paymentinfo.base64;
                //$('.paydialog').slideToggle();
                $('html, body').animate({
                  scrollTop: $('#topay').offset().top
                }, 500, function() {
                });
                self.enqurl = response.body.paymentinfo.enqurl;
                if (self.enqurl != null) {
                  self.checkEnqURL();
                }
              }
              console.log(response.body);
            }, response => {
              self.$root.$emit('modal.msgoverlay', {'mode':'hide'});
              console.log('Error', response);
            });
          }
        },
        {
          "value":self.common_res.message.no
        }
      ];
      this.$root.$emit('modal.msgoverlay', {'mode':'show', 'msg':self.res.confirm_pay, 'icon':'fa-question', 'buttons':buttons});
    },
    amendOrder(evt) {
      var self = this;
      utils.backupCart(self.invoice);
      this.reOrder(evt);
    },
    getName(id, list) {
      if (list != null) {
        for (var i=0;i<list.lenght;i++) {
          if (list[i].id == id) return list[i].name;
        }
      }
      return null;
    },
    getSuffix(name, mapping) {
      var s = 1;
      for (;;) {
        if (s == 1) {
          if (mapping[name] == null) {
            return "";
          }
        } else {
          if (mapping[name+"_"+s] == null) {
            return "_"+s;
          }
        }
        s++;
      }
    },
    getItemByCode(code) {
      for (var i=0;i<this.common_res['items']['item'].length;i++) {
        if (this.common_res['items']['item'][i]['code'] == code) {
          return this.common_res['items']['item'][i];
        }
      }
      return null;
    },
    init:function() {
      var self = this;
      self.topay_btn = this.invoice.shoporder == null?false:utils.getReadyToPayStatus().indexOf(this.invoice.shoporder.payment_status_id) < 0;
      self.curr = utils.getCurrencySym();
      if (this.invoice.currency_symbol != '') {
        self.curr = this.invoice.currency_symbol;
      }
      if (this.invoice.ratedp != '') {
        self.fmt = parseInt(this.invoice.ratedp);
      }
      var shipid = utils.getStorage('shippingid');
      if (shipid != null) {
        self.shippingid = shipid;
      }
      if (self.companyinfo.branch != null) {
        self.shippinginfo = self.companyinfo.branch;
      } else {
        self.shippinginfo = self.companyinfo;
      }
      if (self.shippinginfo.bchid != self.shippingid) {
        if (self.companyinfo.branches != null) {
          for (var i=0;i<self.companyinfo.branches.length;i++) {
            if (self.shippingid == self.companyinfo.branches[i].bchid) {
              self.shippinginfo = self.companyinfo.branches[i];
              break;
            }
          }
        }
        self.shippingid = self.shippinginfo.bchid;
      }

      this.locale = utils.getLocale();
      try {
        var cc = this.invoice.items;
        this.non_items = this.invoice.non_items;
        if (this.invoice.shoporder != null) {
          this.amendable = (this.invoice.bchfk == this.companyinfo.bchid || this.companyinfo.bchid == -1) && utils.getReadyToPayStatus().indexOf(this.invoice.shoporder.payment_status_id) < 0 && utils.getPaidStatus().indexOf(this.invoice.shoporder.payment_status_id) < 0 && this.invoice.picode == this.invoice.bill_no;
//console.log(this.amendable, this.invoice, this.companyinfo);
          //this.paid = utils.getPaidStatus().indexOf(this.invoice.shoporder.payment_status_id) >= 0; 
          //if (utils.getPaidStatus().indexOf(this.invoice.shoporder.payment_status_id) < 0 && utils.getReadyToPayStatus().indexOf(this.invoice.shoporder.payment_status_id) < 0) {
          if (utils.getPaidStatus().indexOf(this.invoice.shoporder.payment_status_id) < 0) {
            for (var i=0;i<this.invoice.non_items.length;i++) {
              var item_itype = this.invoice.non_items[i].itype;
              if (this.paytype.indexOf(item_itype) >= 0) {
                this.payable = item_itype;
                console.log('payable', this.payable);
              }
            }
          }
        }
        this.shippinginfo = {
          "address1":this.invoice.delivery_addr1,
          "address2":this.invoice.delivery_addr2,
          "address3":this.invoice.delivery_addr3,
          "address4":this.invoice.delivery_addr4,
          "name":this.invoice.shipname,
          "poc":this.invoice.name,
          "email":this.invoice.email,
          "tel":this.invoice.contact_phone
        };
        // if the delivery_id == no_shipto, just hide it
        var no_shipto = this.getItemByCode('no_shipto');
        console.log(no_shipto, self.invoice.non_items);
        if (no_shipto != null) {
          for (var i=0;i<self.invoice.non_items.length;i++) {
            if (self.invoice.non_items[i].id == no_shipto.id) {
              this.shippinginfo = null
              break;
            }
          }
        }
        if (cc != null) {
          var url = 'search.is?invcode='+self.invoice.bill_no+'&locale='+this.locale;
          var qtys = {};
          var discounts = {};
          //var subtotal = {};
          var fg = {};
          var td = {};
          var price = {};
          var subtotal = {};
          var wprice = {};
          for (var i=0;i<cc.length;i++) {
            url = url + '&product_id='+cc[i].product_id;
            var oqty = cc[i].qty;
            var suffix = "";
            if (qtys[cc[i].product_id] != null) {
              suffix = "_2";
            }
            cc[i].wbuym = 0;
            cc[i].wfreen = 0;
            if (cc[i].discounts) {
              for (var j=0;j<cc[i].discounts.length;j++) {
                // 2021-10-25
                //if (cc[i].discounts[j].prefix == 'FG' && oqty >= ((cc[i].discounts[j].wbuym + cc[i].discounts[j].wfreen))) {
                if (cc[i].discounts[j].prefix == 'FG') {
                  if (oqty >= ((cc[i].discounts[j].wbuym + cc[i].discounts[j].wfreen))) {
                    oqty = parseInt((oqty / (cc[i].discounts[j].wbuym + cc[i].discounts[j].wfreen) - 0.5).toFixed(0)) * cc[i].discounts[j].wbuym + (oqty % (cc[i].discounts[j].wbuym + cc[i].discounts[j].wfreen));
                  }
                  fg[cc[i].product_id+suffix] = cc[i].discounts[j];
                  cc[i].wbuym = cc[i].discounts[j].wbuym;
                  cc[i].wfreen = cc[i].discounts[j].wfreen;
                } else if (cc[i].discounts[j].calamt == null || cc[i].discounts[j].calamt == 0) {
                  if (cc[i].discounts[j].dval != null) {
                    cc[i].discounts[j].calamt = cc[i].discounts[j].dval;
                  } else {
                    cc[i].discounts[j].calamt = (cc[i].discounts[j].dprice / (cc[i].price * cc[i].qty)).toFixed(2);
                  }
                }
              }
            }
            cc[i].oqty = oqty;
            cc[i].subtotal = cc[i].sub_total;
            cc[i].unitprice = cc[i].price;
            cc[i].sale_price = cc[i].price;
            qtys[cc[i].product_id+suffix] = oqty;
            td[cc[i].product_id+suffix] = cc[i].tradedis;
            price[cc[i].product_id+suffix] = cc[i].price;
            wprice[cc[i].product_id+suffix] = cc[i].wprice;
            discounts[cc[i].product_id+suffix] = cc[i].discounts;
            subtotal[cc[i].product_id+suffix] = cc[i].subtotal;
          }
          if (cc.length > 10) {
            self.$root.$emit('modal.msgoverlay', {'mode':'show', 'msg':self.common_res.message.waiting});
          }
          Vue.http.get(utils.getServerPath()+'/cart/'+url).then(response => {
            //self.products = response.body.productlist;
            self.products = JSON.parse(JSON.stringify(self.invoice.items));
            var lastid = -1;
            var suffix = "";
            for (var i=0;i<self.products.length;i++) {
              var found = false;
              for (var j=0;j<response.body.productlist.length;j++) {
                if (response.body.productlist[j].pdetails['product_id'] == self.products[i].product_id) {
                  found = true;
                  var p = response.body.productlist[j];
                  self.products[i].pdetails = p.pdetails;
                  self.products[i].large_obj = p.large_obj;
                  self.products[i].small_obj = p.small_obj;
                  self.products[i].img_tag2 = p.img_tag2;
                  self.products[i].fqty = self.products[i].qty;
//console.log(self.products[i]);
                  break;
                }
              }
              if (!found) {
                self.products[i].pdetails = {'product_id':self.products[i].product_id};
                console.log('missing product:', self.products[i]);
              }
            }
// disabled @20190814
if (1==2) {
            for (var i=0;i<self.products.length;i++) {
              if (lastid == self.products[i].pdetails.product_id) {
                suffix = "_2";
              } else {
                suffix = "";
              }
              lastid = self.products[i].pdetails.product_id;
              self.products[i].oqty = qtys[self.products[i].pdetails.product_id+suffix];
              self.products[i].discounts = discounts[self.products[i].pdetails.product_id+suffix];
              self.products[i].sale_price = price[self.products[i].pdetails.product_id+suffix];
              self.products[i].unitprice = price[self.products[i].pdetails.product_id+suffix];
              self.products[i].wprice = wprice[self.products[i].pdetails.product_id+suffix];
              self.products[i].tradedis = td[self.products[i].pdetails.product_id+suffix];
              self.products[i].subtotal = subtotal[self.products[i].pdetails.product_id+suffix];
              self.products[i].wbuym = 0;
              self.products[i].wfreen = 0;
              if (fg[self.products[i].pdetails.product_id+suffix] != null) {
                self.products[i].wbuym = fg[self.products[i].pdetails.product_id+suffix].wbuym;
                self.products[i].wfreen = fg[self.products[i].pdetails.product_id+suffix].wfreen;
              }
              //self.subtotal.push(subtotal[self.products[i].pdetails.product_id+suffix]);
              self.subtotal.push(0);
            }
}
            self.setPos();
            self.pagination = response.body.pagination;
            if (self.pagination) {
              self.pageno = parseInt(self.pagination.current_page / self.pagination.num);
            }
            if (cc.length > 10) {
              setTimeout(function() {
                self.$root.$emit('modal.msgoverlay', {'mode':'hide'});
              }, 50);
            }
          }).catch(err => {
console.log(err);
          });
        }
      } catch (e) {}
    },
    setPos:function() {
      var self = this;
      var pos = 0;
      var deta = 0;
      for (var i=0;i<self.products.length;i++) {
        self.products[i].pos = pos + deta;
        pos++;
        if (self.products[i].wcaseqty > 0 && self.products[i].wcasedct > 0) {
          deta++;
        }
      }
    },
    setSubTotal:function(st) {
      if (st.qty) {
        this.products[st.idx].qty = st.qty;
      }
      this.products[st.idx].subtotal = st.subtotal;
      this.subtotal[st.idx] = st.subtotal;
      var totalamt = 0;
      try {
        for (var i=0;i<this.subtotal.length;i++) {
          totalamt = totalamt + this.subtotal[i];
        }
      } catch (e) {
      }
      this.totala = totalamt;
      this.$forceUpdate();
    },
    chk: function(name, regex, errmsg) {
      // mandatory
      // if (0 == mode) {
      if (regex) {
        var chkval = (this.reseller[name])?this.reseller[name]:'';
        if (!regex.test(chkval)) {
          if (errmsg) this.error[name] = errmsg;
          else this.error[name] = " This is required";
//console.log('false:'+name+":"+chkval);
          return false;
        } else {
          delete this.error[name];
          return true;
        }
      }
      // }
    },
    getText(node) {
      var d = $('<div>'+(node)+'</div>');
      return d.text();
    },
    dnProductsList() {
      var self = this;
      var list = '';
      for (var i=0;i<self.products.length;i++) {
        list = list + (self.products[i].qty+' x ' + self.products[i].pdetails.product_name + " {"+self.products[i].pdetails.product_id+"}");
        if (i < self.products.length -1) {
          list = list + '\n';
        }
      }
      console.log(list);
      utils.download("bulk.txt", list);
    },
    deleteAllProducts() {
      var self = this;
      var buttons = [
        {
          "value":this.common_res.message.yes,
          "func":function() {
            self.$root.$emit('remove', {'all':true});
            self.$root.$emit('modal.msgoverlay', {'mode':'hide'});
          }
        },
        {
          "value":this.common_res.message.no
        }
      ];
      this.$root.$emit('modal.msgoverlay', {'mode':'show', 'msg':self.res.confirm_delete, 'icon':'fa-question', 'buttons':buttons});
    }
  },
  mounted: function() {
    var self = this;
    // 3D is completed
    window.addEventListener('message', function(ev) {
      if (ev.data === '3DS-authentication-complete') {
        self.stripe_obj.retrievePaymentIntent(
          self.clientSecret
        ).then(function(result) {
          //console.log(result);
          if (result.error) {
            window.location.reload();
          } else if (result.paymentIntent.last_payment_error) {
            $('#3ds').remove();
            self.$root.$emit('modal.blank', {'mode':'hide'});
            setTimeout(function() {
              console.log(result.paymentIntent.last_payment_error);
              //self.$root.$emit('modal.msgoverlay', {'mode':'show', 'msg':result.paymentIntent.last_payment_error.message, 'button':self.common_res.message.close, 'icon':'fa-exclamation'});
              self.$root.$emit('modal.msgoverlay', {'mode':'show', 'msg':self.common_res.message.retry_cc, 'button':self.common_res.message.close, 'icon':'fa-exclamation'});
            }, 100);
          }
        });
      }
    }, false);
  }
}
</script>



// WEBPACK FOOTER //
// src/components/OrderDetails.vue